export const interest_rate = 0.949999
